import { FC, SVGProps } from 'react';

export const RedArrowDown: FC<SVGProps<SVGSVGElement>> = props => (
	<svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path d="M10.3333 1.16669L5.66667 5.83335L1 1.16669" stroke="#FB5353" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
	</svg>
);
